export const SUPPORTED_LANGUAGES = ["en", "ar"] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]
export const DEFAULT_LANGUAGE: SupportedLanguage = "en"

export function normalizeLanguage(value: string | null | undefined): SupportedLanguage | null {
  if (!value) {
    return null
  }

  const normalized = value.toLowerCase()

  if (normalized.startsWith("ar")) {
    return "ar"
  }

  if (normalized.startsWith("en")) {
    return "en"
  }

  return null
}
